<template lang="pug">
  .steps.flex-container
    .step-text {{ title }}
    .step-bar
      .step(:class="status_initial")
        .hidden-bar(:style='{ width: percentage(upload_progress) }')
        label(:style="{ left: '-'+steps_labels[0].length+'%' }") {{ steps_labels[0] }}
      .step(:class="status_validation")
        .hidden-bar(:style='{ width: percentage(validation_progress) }')
        label(:style="{ left: '-'+steps_labels[1].length+'%' }") {{ steps_labels[1] }}
      .step(:class="status_organization")
        .hidden-bar(:style='{ width: percentage(creation_progress) }')
        label(:style="{ left: '-'+steps_labels[2].length+'%' }") {{ steps_labels[2] }}
      .step(:class="status_send_to_base")
        label(:style="{ left: '-'+steps_labels[3].length+'%' }") {{ steps_labels[3] }}
    div.step-status Passo 0{{ current_step }} de 0{{ steps.length }}
</template>

<script>
exports.default = {
  props: {
    current_step: { default: 1 },
    title: { default: "" },
    upload_progress: { default: 0 },
    validation_progress: { default: 0 },
    creation_progress: { default: 0 },
    steps_labels: { default: ["Busca","Validação","Organização","Envio para a base"] }
  },
  data() {
    return {
      status_initial: "current",
      status_validation: "",
      status_organization: "",
      status_send_to_base: ""
    }
  },
  methods: {
    percentage(value) {
      if(value > 90 ) { value = 90 }
      return value+"%"
    }
  },
  watch: {
    current_step(val) {
      switch (val) {
        case 1:
          this.status_initial = "current"
          this.status_validation = ""
          this.status_organization = ""
          this.status_send_to_base = ""
          return
        case 2:
          this.status_initial = "done"
          this.status_validation = "current"
          this.status_organization = ""
          this.status_send_to_base = ""
          return
        case 3:
          this.status_initial = "done"
          this.status_validation = "done"
          this.status_organization = "current"
          this.status_send_to_base = ""
          return
        case 4:
          this.status_initial = "done"
          this.status_validation = "done"
          this.status_organization = "done"
          this.status_send_to_base = "current"
          return
        default:
          this.status_initial = "done"
          this.status_validation = "done"
          this.status_organization = "done"
          this.status_send_to_base = "done"
      }
    }
  },
  created() {
    this.steps=[1,2,3,4]
  }
}

</script>

<style lang="sass" scoped>
@import '../../assets/stylesheets/_variables.sass'

.flex-container
  display: flex

.step-text
  flex: 2.7

.steps
  position: relative
  background-color: $lightest-gray
  font-family: Montserrat
  font-size: 12px
  font-weight: 100
  color: #081a40
  padding: 0 18px 0 28px
  max-width: 1130px
  height: 80px
  z-index: 2
  align-items: center

  .step-bar
    display: flex
    flex: 8
    height: 10px
    margin-top: -8px
    
    .step
      position: relative
      flex-grow: 1

      .hidden-bar
        position: absolute
        display: block
        background-color: #08d4a7
        border-radius: 5px
        height: 3px
        top: 5px
        left: 17px
        z-index: 10
        transition: width 1s

      &:first-child
        &:after
          display: none

      &.done
        &:before
          background-color: $reev-base-green
          border: none
          background-image:  url('../../assets/images/icons/checkbox.png')
          background-repeat: no-repeat
          background-position: center
        &:after
          background: $reev-base-green
      &.current
        &:before
          border-color: $reev-base-green
        &:after
          background: $reev-base-green

      label
        position: absolute
        top: 20px
        font-size: 9px
        font-weight: 100
        color: #081a40
        text-transform: uppercase

      // Círculo
      &:before
        position: absolute
        content: ''
        width: 14px
        height: 14px
        border-radius: 50%
        border: 1px solid #bbc4cc

      // Linha
      &:after
        position: absolute
        content: ''
        width: calc(100% - 20px)
        height: 1px
        background: #bbc4cc
        right: 101.5%
        top: 6px
</style>



// WEBPACK FOOTER //
// step_bar.vue?1dfa94a0